import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryItemSummary } from '@/renderer/services/inventoryItemService';
import type { InventoryItemFilterParams } from '@/renderer/types/inventory';

export function useInventoryItemSummary(
  companyId: number | null | undefined,
  search: string,
  categoryId: InventoryItemFilterParams['categoryId'],
  status: InventoryItemFilterParams['status'],
) {
  return useQuery({
    queryKey: queryKeys.inventory.itemSummary(
      companyId ?? 0,
      search,
      categoryId ?? 'all',
      status ?? 'all',
    ),
    queryFn: async () => {
      const result = await fetchInventoryItemSummary(
        companyId ?? 0,
        search,
        categoryId,
        status,
      );
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch inventory summary');
      }

      return result.data;
    },
    enabled: !!companyId,
  });
}
